import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertType } from 'src/app/core/enums/enums';
import { Passenger, QuoteRequest } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';

@Component({
  selector: 'app-step-split',
  templateUrl: './step-split.component.html'
})
export class StepSplitComponent {
  @Input() quote: QuoteRequest;
  @Input() splitState = AlertType.Warning;
  @Input() splitError: ContractError;
  @Input() newPnr: string;
  @Input() isOpenTicketMode: boolean;
  @Input() passengers: Passenger[];

  @Output() cancelSplit = new EventEmitter<boolean>();
  @Output() split = new EventEmitter<QuoteRequest>();
  @Output() continue = new EventEmitter<boolean>();

  alertType = AlertType;

  constructor() {}
}
